// src/RegisterModal.jsx
import React, { useState, useEffect } from "react";
import axios from "axios";

const RegisterModal = ({ isOpen, onClose, onSwitchToLogin, initialRole }) => {
  const [form, setForm] = useState({
    username: "",
    email: "",
    password: "",
    role: initialRole || "client",
  });
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");

  useEffect(() => {
    setForm((prevForm) => ({ ...prevForm, role: initialRole || "client" }));
  }, [initialRole]);

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post("https://quirkleai.com/api/register/", form);
      setMessage("✅ Registration successful! Please check your email to activate your account.");
      setError("");
      setTimeout(() => {
        onClose();
        onSwitchToLogin();
      }, 3000); // Auto-close and switch to login after 3 seconds
    } catch (err) {
      setError("❌ Registration failed. Username/email may already exist.");
      setMessage("");
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
      <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-sm">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold">Register</h2>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-800">&times;</button>
        </div>
        {error && <p className="text-red-500">{error}</p>}
        {message && <p className="text-green-500">{message}</p>}
        <form onSubmit={handleSubmit} className="space-y-3">
          <input
            name="username"
            placeholder="Username"
            value={form.username}
            onChange={handleChange}
            className="w-full p-2 border rounded"
          />
          <input
            name="email"
            placeholder="Email"
            value={form.email}
            onChange={handleChange}
            className="w-full p-2 border rounded"
          />
          <input
            name="password"
            type="password"
            placeholder="Password"
            value={form.password}
            onChange={handleChange}
            className="w-full p-2 border rounded"
          />
          <select
            name="role"
            value={form.role}
            onChange={handleChange}
            className="w-full p-2 border rounded"
          >
            <option value="client">Client</option>
            <option value="therapist">Therapist</option>
            <option value="supervisor">Supervisor</option>
          </select>
          {form.role === "therapist" && (
            <input
              name="category"
              placeholder="Therapist Category (e.g., anxiety, depression)"
              value={form.category || ""}
              onChange={handleChange}
              className="w-full p-2 border rounded"
            />
          )}
          <button type="submit" className="w-full bg-green-600 text-white p-2 rounded">
            Register
          </button>
          <p className="text-center text-sm">
            Already have an account?{" "}
            <button
              type="button"
              onClick={onSwitchToLogin}
              className="text-blue-600 hover:underline"
            >
              Login
            </button>
          </p>
        </form>
      </div>
    </div>
  );
};

export default RegisterModal;